import React, {FunctionComponent, MouseEventHandler} from "react";
import clsx from "clsx";
import {createUseStyles} from "react-jss";
import SendIcon from "./SendIcon";
import {Theme} from "engage-client/theme";

type SubmitButtonProps = {
    className?: string
    disabled?: boolean
    onClick?: MouseEventHandler<HTMLButtonElement>
    type?: "submit" | "reset" | "button"
}

const useStyles = createUseStyles<Theme>((theme) => ({
    submitButton: {
        userSelect: "none",
        alignItems: "center",
        background: theme.questionSubmit.background,
        border: theme.questionSubmit.border,
        borderRadius: theme.questionSubmit.borderRadius,
        color: theme.questionSubmit.foreground,
        cursor: "pointer",
        display: "flex",
        fontFamily: '"Anova", "Roboto", "Helvetica", "Arial", "sans-serif"',
        fontSize: 24,
        fontWeight: theme.questionSubmit.fontWeight ?? 400,
        height: 48,
        justifyContent: theme.questionSubmit.icon ? "flex-end" : "center",
        margin: 0,
        padding: 0,
        width: 144,
        outline:0,
        textDecoration: "none",
        "-webkit-appearance": "none",
        "-webkit-tap-highlight-color": "transparent",
        "&:disabled": {
            cursor: "default",
            opacity: .7
        }
    },
    iconWrapper: {
        color: theme.questionSubmit.icon?.color ?? "",
        backgroundColor: theme.questionSubmit.icon?.backgroundColor ?? "",
        borderRadius: 18,
        height: 36,
        width: 36,
        display: theme.questionSubmit.icon ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: 6,
        marginRight: 4
    }
}));

const SubmitButton: FunctionComponent<SubmitButtonProps> = (props) => {
    const {className, onClick, disabled = false, type} = props;
    const classes = useStyles();

    return <button className={clsx(className, classes.submitButton)}
                   disabled={disabled}
                   onClick={onClick}
                   type={type}
                   data-qa="submit-button" >
        Submit<div className={classes.iconWrapper}><SendIcon /></div>
    </button>;
};

export default SubmitButton;